import i18n from 'i18next'

import { ACTION, TYPE, ListenerObj } from './defConstants'

import { ThreadObjInterface } from './ThreadObj'
import EmailObj from './EmailObj'

export type MailboxData = {
  threadList?: ThreadObjInterface[]
  emailList?: EmailObj[]
  emailListForEmailType?: EmailObj[]
} | null

// MailboxObj 추상 클래스에서 getJmapFilter 제거
export abstract class MailboxObj {
  isRealMailbox: boolean
  dataMgr: any
  threadChangeListener: any
  data: any
  isEmailType: boolean
  sortInfo: any
  threadList: ThreadObjInterface[]
  emailList: EmailObj[]
  emailListForEmail: EmailObj[]

  constructor(dataMgr: any) {
    this.threadChangeListener = new ListenerObj('ThreadListChange', this)
    this.dataMgr = dataMgr
    this.isRealMailbox = true
    this.sortInfo = undefined
    // 방어 초기화: 서브클래스가 재할당하지 않아도 목록 필드가 undefined로 남지 않도록 보장.
    // (OMD-234: SpamSniperMailbox가 emailListForEmail을 초기화하지 않아 getEmailById에서 크래시)
    this.threadList = []
    this.emailList = []
    this.emailListForEmail = []
  }

  setSortInfo = (sortInfo: any) => {
    this.sortInfo = sortInfo
  }

  getSortInfo = () => {
    if (this.sortInfo == null) {
      return {
        type: 'sort_date',
        direction: 'sort_desc',
      }
    }
    return this.sortInfo
  }

  // mailbox 자체에서 자신의 정보 (count 등) 업데이트 필요 시 재정의
  // JMAPMailbox는 DataManager에서 mailbox정보를 업데이트하므로 재정의 필요 없음.
  updateData = async (): Promise<any> => {
    return await Promise.resolve(null)
  }

  getViewCountInfo = (): { count: number | null; type: string } | null => {
    return null
  }

  isSelectable = (): boolean => {
    return true
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  onClick = (e: any, runCommand: any) => {
    console.log(' -- onClick : ', e)
  }

  abstract setRole(role: any): any
  abstract rename(newName: any): any
  abstract getParentMailbox(): any
  abstract isContain(email: any): boolean
  // 삭제 시 동장 모드
  // 'delete' - trash mailbox로 이동.
  // 'destroy' - 메일 완전 삭제.
  abstract getEmailDeleteType(): string
  // 메일 목록 툴바 모드
  // 'all' - 모든 버튼 표시.
  // 'onlyDelete' - 삭제 버튼만 표시.
  abstract getToolbarMode(): string
  abstract getEmailById(id: any): any
  abstract changeParent(newParentId: any, newName?: any): any
  // 메일박스를 삭제. (deleteEmails: 메일 삭제 여부)
  abstract delete(deleteEmails?: boolean): any
  // 메일박스 하위 메일박스 삭제. (deleteSelf: 자신 메일박스 삭제 여부)
  abstract deleteChild(deleteSelf?: boolean): any
  // 이메일 삭제.
  abstract deleteEmails(emailList: any): any
  // 하위 폴더 가능 여부
  abstract childEnabled(): boolean
  abstract getListType(): any
  abstract notifyCountChanged(count: any): void
  abstract getResultFilter(): any
  abstract resetData(): void
  abstract resetReqData(): void
  abstract reqNextThreadList(offset?: number, info?: any, dataInfo?: any, needTotal?: boolean): any
  abstract reqUpdatedThreadData(isSave?: any): Promise<any>
  abstract getReqState(): number
  abstract getThreadById(id: any): any
  abstract getThreadEmailfilter(): any
  abstract setEmailSearch(text: string | null): void
  abstract isMoveEnabled(): boolean
  abstract isSentMailbox(): boolean
  abstract setLimit(limit: number): void

  getId = () => {
    return this.data.id
  }

  // role은 항상 소문자로 처리할 것.
  getRole = () => {
    return (this.data.role || '').toLowerCase()
  }

  getDisplayName = () => {
    let displayName = ''
    const role = this.getRole()
    switch (role) {
      case 'inbox':
      case 'archive':
      case 'drafts':
      case 'sent':
      case 'junk':
      case 'trash':
      case 'outbox':
        /* i18next-extract-disable-next-line */
        displayName = i18n.t(`mailbox.displayName.${role}`)
        break
      default:
        displayName = this.data.name
    }

    return displayName
  }

  getName = () => {
    return this.data.name
  }

  getFullName = () => {
    let cur = this
    let name = cur.getDisplayName()
    while (cur.data.parentId != null) {
      cur = this.dataMgr.getMailboxById(cur.data.parentId)
      name = `${cur.getDisplayName()}/${name}`
    }
    return name
  }

  isfolderNameVisible = (emailObj: any) => {
    return this.isContain(emailObj) !== true
  }

  // notifyChangeAll, notifyReload 공통 구현
  notifyChangeAll() {
    const threadData = [
      {
        targetType: TYPE.MAILBOX,
        target: this,
        action: ACTION.SET,
        type: TYPE.THREAD,
        data: this.getAllData(),
      },
    ]
    this.threadChangeListener.notify(threadData)
  }

  notifyReload() {
    const threadData = [
      {
        targetType: TYPE.MAILBOX,
        target: this,
        action: ACTION.RELOAD,
        type: TYPE.THREAD,
      },
    ]
    this.threadChangeListener.notify(threadData)
  }

  getAllData(): MailboxData {
    if (this.isEmailType === true) {
      return {
        emailList: this.emailList,
        threadList: this.threadList,
        emailListForEmailType: this.emailListForEmail,
      }
    }
    return {
      emailList: this.emailList,
      threadList: this.threadList,
    }
  }

  getLimitEmail() {
    return null
  }
}

export default MailboxObj
